function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_11230_208833)"
}, React.createElement("path", {
  d: "M9.16634 5.83325H4.99967C4.55765 5.83325 4.13372 6.00885 3.82116 6.32141C3.5086 6.63397 3.33301 7.05789 3.33301 7.49992V14.9999C3.33301 15.4419 3.5086 15.8659 3.82116 16.1784C4.13372 16.491 4.55765 16.6666 4.99967 16.6666H12.4997C12.9417 16.6666 13.3656 16.491 13.6782 16.1784C13.9907 15.8659 14.1663 15.4419 14.1663 14.9999V10.8333",
  stroke: "url(#paint0_linear_11230_208833)",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M8.33301 11.6666L16.6663 3.33325",
  stroke: "url(#paint1_linear_11230_208833)",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M12.5 3.33325H16.6667V7.49992",
  stroke: "url(#paint2_linear_11230_208833)",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_11230_208833",
  x1: 8.13059,
  y1: 16.8055,
  x2: 8.13059,
  y2: 5.69436,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#3A70BF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#3A95F4"
})), React.createElement("linearGradient", {
  id: "paint1_linear_11230_208833",
  x1: 12.0235,
  y1: 11.7734,
  x2: 12.0235,
  y2: 3.22641,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#3A70BF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#3A95F4"
})), React.createElement("linearGradient", {
  id: "paint2_linear_11230_208833",
  x1: 14.3452,
  y1: 7.55334,
  x2: 14.3452,
  y2: 3.27983,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#3A70BF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#3A95F4"
})), React.createElement("clipPath", {
  id: "clip0_11230_208833"
}, React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})));

var SvgViewDark = function SvgViewDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgViewDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/view-dark.465e86a4.svg";
export { ForwardRef as ReactComponent };